module.exports = {"description":"","displayName":"SpriteMap","methods":[],"props":{"id":{"type":{"name":"string"},"required":false,"description":"HTML id attribute","defaultValue":{"value":"undefined","computed":true}},"spriteTemplate":{"type":{"name":"shape","value":{"__html":{"name":"string","required":false}}},"required":false,"description":"Custom SVG sprite","defaultValue":{"value":"{ __html: spriteHtml }","computed":false}}}}


//////////////////
// WEBPACK FOOTER
// ./.lochness/props/SpriteMap-props.json
// module id = 470
// module chunks = 0